import * as React from "react";
import { Accordion, Panel } from "baseui/accordion";
import { AdminCoversSection } from "./AdminCoversSection";
import { AdminRiskStateSection } from "./AdminRiskStateSection";
import { FC } from "react";
import { SummaryCard } from "./SummaryCard";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";

type TExposureItem = {
  exposureId: string;
  name: string;
  is_policy_level: boolean;
  key: string;
  product_key: string;
  type: string;
  type_name: string;
};
type AdminExposuresSectionProps = {
  enabledExposures: TExposureItem[];
  availableCovers: TCoverSection[];
  quote: TQuote;
  riskProfile: TRiskProfile;
};
export const AdminExposuresPolicySection: FC<AdminExposuresSectionProps> = ({
  enabledExposures,
  availableCovers,
  quote,
  riskProfile,
}) => {
  return (
    <Accordion>
      {enabledExposures?.map((enabledExposure, index) => {
        return (
          <Panel title={enabledExposure?.name} key={index}>
            <AdminExposure
              exposureItem={enabledExposure}
              availableCovers={availableCovers}
              questionSets={quote?.product?.exposures
                ?.find((exp) => exp?.type === enabledExposure?.type)
                ?.exposureQuestionSets?.filter(
                  (eqs) => eqs?.exposureItemKey === enabledExposure?.key
                )
                ?.map((eqs) => eqs?.questionSet)}
              riskProfile={riskProfile}
            />
          </Panel>
        );
      })}
    </Accordion>
  );
};

type AdminExposureProps = {
  exposureItem: TExposureItem;
  availableCovers: TCoverSection[];
  questionSets: TQuestionSet[];
  riskProfile: TRiskProfile;
};
const AdminExposure: FC<AdminExposureProps> = ({
  availableCovers,
  exposureItem,
  riskProfile,
  questionSets,
}) => {
  const availableExposureCovers = availableCovers?.filter((cover) => {
    return cover?.key?.includes(exposureItem?.key);
  });
  return (
    <VerticalSpacer>
      <SummaryCard data-testid="adminPolicyHolderSection" title="Policy details">
        <AdminRiskStateSection riskProfile={riskProfile} questionSets={questionSets} />
      </SummaryCard>
      <SummaryCard data-testid="adminCoversSection" title="Policy Covers">
        <AdminCoversSection
          covers={exposureItem?.enabledCovers}
          availableCovers={availableExposureCovers}
        />
      </SummaryCard>
    </VerticalSpacer>
  );
};
